import { type BadgeProps, Box, Text } from "@chakra-ui/react";
import type { CommandStatus } from "../types/command.types";
import Badge from "./Badge";
import { mapping } from "./CommandStatusBadge";

function OrderStatusBadge({
	halted,
	status,
	width = "fit-content",
	...props
}: {
	halted: boolean;
	status: CommandStatus | "HALTED";
	width?: string;
} & BadgeProps) {
	const generateBadge = (
		textColor: string,
		borderColor: string,
		backgroundColor: string,
		label: string,
	) => {
		return (
			<Badge
				w={width}
				fontSize="14px"
				maxHeight="26px"
				fontWeight={500}
				px="12px"
				rounded={1000}
				backgroundColor={backgroundColor}
				color={textColor}
				border={"solid 1px"}
				borderColor={borderColor}
				textAlign="center"
				ml={props.ml}
				display="flex"
				flexDirection={"row"}
				alignItems={"center"}
				gap={1}
			>
				<Box w="8px" h="8px" backgroundColor={textColor} rounded={1000} />
				<Text whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis">
					{label}
				</Text>
			</Badge>
		);
	};
	// 1. Halted special case
	if (halted) {
		return generateBadge("#FFFFFF", "#C2410C", "#F68511", "En pause");
	}
	const statusMapping = mapping.get(status);
	if (!statusMapping) {
		return <>---</>;
	}
	return generateBadge(...statusMapping);
}

export default OrderStatusBadge;
